// test1765
(1765 && 0);
